import { React, useState } from 'react';
import '../../css/M_Layout.css';
import { FiMenu } from "react-icons/fi";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { FaArrowLeft } from "react-icons/fa6";
import { useNavigate, Outlet } from "react-router-dom";
import Nav from './Nav'

export const Header = ((ref) => {
  const navigate = useNavigate();
  const [navFlag, setNavFlag] = useState(false);

  const handleNavFlag = () => {
    // Nav Icon 클릭 시 Nav 열기/닫기 가능.
    setNavFlag(!navFlag);
  };

  const handleNavFlagFalse = () => {
    // Nav 밖에 다른곳을 클릭하면 자동으로 Nav 닫기.
    setNavFlag(false);
  };

  const handleLogout = () => {
    localStorage.setItem("LogoutType", 'C');
    navigate("/Logout");
  };

  const goToMain = () => {
    return navigate(localStorage.getItem("main"));
  };

  return (
    <>
    <header className="M_header">
        <div style={ { width: '100%' } }>
        <div className="M_NavIcon" onClick={handleNavFlag}>
          {navFlag? (<FaArrowLeft size="30" />) : (<FiMenu size="30" />)}
        </div>
        {(localStorage.getItem("deviceType") === "A" || localStorage.getItem("deviceType") === "I" || localStorage.getItem("deviceType") === "M")? 
        <div onClick={goToMain} className="M_CompnayNM">{ localStorage.getItem("company_nm") }</div>
        :
        <div onClick={goToMain} className="M_CompnayNM">{ localStorage.getItem("company_nm") }</div>}
        <div className="M_LogoutIcon">
          <RiLogoutBoxRLine size="30" onClick={handleLogout} />
        </div>
        <div className="M_UserNM">{ localStorage.getItem("user_nm") }</div>
      </div>
    </header>
    <div style={ { position: 'relative', overflowY: 'auto', overflowX: 'hidden', width: '100%', minHeight: 'calc(100vh - 50px)', backgroundColor : 'white' } }>
        <Nav getNavFlag={navFlag} handleNavFlagFalse={handleNavFlagFalse} />
        <div>
        <Outlet />
        </div>
    </div>
    </>
  );
});

export default Header;